import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import SesionSinRespuesta from "@/components/SesionSinRespuesta";
import SesionFrenada from "@/components/SesionFrenada";
import CambiarClave from "@/components/CambiarClave";
import PuertaDeEdad from "@/components/PuertaDeEdad";
import PuertaDeFicha from "@/components/PuertaDeFicha";

export default function ProtectedRoute({ children }) {
  const { user, ready, sesion } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="min-h-[calc(100vh-4rem)] dvh:min-h-[calc(100svh-4rem)] bg-white flex items-center justify-center">
        <div className="font-mono-alpha text-[11px] uppercase tracking-widest text-alpha-black/40">
          Verificando sesión...
        </div>
      </div>
    );
  }
  // SIN RESPUESTA NO ES ESTAR FUERA (24 sep 2026). Si el servidor no ha contestado a «¿quién
  // soy?» —red, 502, tiempo agotado—, no se manda a nadie a la pantalla de acceso: se dice que
  // no se ha podido comprobar y se ofrece reintentar. El porqué, en `context/AuthContext.jsx`.
  if (sesion === "sin-respuesta") {
    return <SesionSinRespuesta />;
  }
  // Y UN FRENO TAMPOCO ES ESTAR FUERA (6 oct 2026). El servidor ha contestado —429, «vas
  // demasiado rápido»— y hasta dice cuánto falta. Ni formulario de acceso ni pantalla de
  // reconexión: se dice lo que pasa y no se reintenta solo.
  if (sesion === "freno") {
    return <SesionFrenada />;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  // LA CUENTA DE AULA NACE CON UNA CONTRASENA IMPRESA, y hasta que el alumno pone la suya
  // la cuenta no es de nadie: la sabe quien repartio el papel y quien se sento al lado. Se
  // corta AQUI y no en una ruta propia, porque asi no hay pagina con sesion que se escape.
  if (user.debe_cambiar_clave) {
    return <CambiarClave />;
  }
  // LA EDAD, Y EL PERMISO DE QUIEN DECIDE POR UN MENOR DE CATORCE. Se corta aqui por lo
  // mismo que lo de arriba: asi no hay pantalla con sesion que se escape. El servidor corta
  // ademas por su cuenta -en `get_current_user`, con un 403-, y esto no lo sustituye: esto
  // es para que el alumno vea QUE le falta en vez de una pantalla en blanco.
  if (user.edad_estado && user.edad_estado !== "libre") {
    return <PuertaDeEdad />;
  }
  // QUIEN ES Y EN QUE CURSO ESTA. Va DESPUES de la edad y no antes: si a esta cuenta le
  // falta el permiso de un tutor, lo que no se puede es empezar a pedirle el nombre y los
  // apellidos mientras se comprueba si se le puede pedir algo.
  if (user.ficha_completa === false) {
    return <PuertaDeFicha />;
  }
  return children;
}
